import { bootstrapApplication } from '@angular/platform-browser'
import { environment } from '@cr-environments/environment'
import * as Sentry from '@sentry/angular'
import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'

Sentry.init({
  dsn: 'https://51dba394324f4461a00d8d20ac9e68cb@o136722.ingest.sentry.io/5201311',
  environment: environment.sentryEnv.toString(),
  release: `${environment.sentryEnv.toString()}`,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      networkDetailAllowUrls: [/\/charge-points\//],
      networkRequestHeaders: ['X-Custom-Header'],
      networkResponseHeaders: ['X-Custom-Header'],
      networkCaptureBodies: true,
    }),
  ],
  tracesSampleRate: 1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
  enableLogs: true,
  sendDefaultPii: true,

  // Filter List before sending events
  beforeSend(event, hint) {
    const error = hint?.originalException
    const err: any = error

    // Check if it's an HTTP error and do not report 4xx errors since some are expected (e.g., 404)
    if (err && err.name === 'HttpErrorResponse') {
      // Filter out specific status codes (4xx)
      if (err.status >= 400 && err.status < 500) {
        return null
      }

      // Filter out "0 Unknown Error" in general because almost all of them are coming from AdBlockers and CORS (CORS/Network/Cancelled)
      if (err.status === 0) {
        return null
      }
    }

    // Filter the "0 Unknown Error" specifically since we had this thousands of times in Sentry
    const exceptionValue = event.exception?.values?.[0]?.value
    if (
      (event.message && event.message.includes('Http failure response') && event.message.includes(': 0')) ||
      (exceptionValue && exceptionValue.includes('Http failure response') && exceptionValue.includes(': 0'))
    ) {
      return null
    }

    return event
  },
})

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err))
